
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-semantics',
  templateUrl: './semantics.component.html',
  styleUrls: ['./semantics.component.css']
})
export class SemanticsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {}

}
